import React from "react"
import classNames from "classnames"
import Breadcrumbs from "../../../../components/elements/Breadcrumbs"
import { paths } from "../../../../routes/paths"
import styles from "./index.module.scss"

const CaptionWrapper = ({ state }) => {
  const { itemCount, query } = state.requestResultGroup
  return !query ? (
    <div className={styles.topCaption}>
      <div className={styles.container}>
        <span>
          Popular in Community
          <span className={classNames(styles.line, styles.toLeft)}></span>
          <span className={classNames(styles.line, styles.toRight)}></span>
        </span>
      </div>
    </div>
  ) : (
    <div className={styles.container}>
      <div className={styles.searchCaption}>
        <Breadcrumbs
          classes={styles.breadcrumb}
          chain={[
            {
              link: paths.questionSearch(),
              text: "Community",
            },
            { text: "Search" },
          ]}
        />
        {!!itemCount && (
          <p className={styles.resultCount}>
            {query
              ? `We found ${itemCount} results for “${query}”`
              : "No questions yet"}
          </p>
        )}
      </div>
    </div>
  )
}
export default CaptionWrapper
